import { useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export function usePdfDownload() {
  const [isGenerating, setIsGenerating] = useState(false);

  const downloadPdf = async (
    elementRef,
    filename = "document.pdf",
    options = {}
  ) => {
    const {
      width = 794,
      height = 1123,
      labelMode = false,
    } = options;

    if (!elementRef?.current) return;
    setIsGenerating(true);

    try {
      const el = elementRef.current;

      const canvas = await html2canvas(el, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: "#ffffff",
        logging: false,
      });

      const imgData = canvas.toDataURL("image/png");

      let pdfW, pdfH, unit;
      if (labelMode) {
        pdfW = 100;
        pdfH = 150;
        unit = "mm";
      } else {
        pdfW = 210;
        pdfH = 297;
        unit = "mm";
      }

      const pdf = new jsPDF({
        orientation: pdfH > pdfW ? "portrait" : "landscape",
        unit,
        format: labelMode ? [pdfW, pdfH] : "a4",
      });

      const canvasW = canvas.width;
      const canvasH = canvas.height;
      const ratio = canvasW / canvasH;
      const pageW = pdfW;
      const pageH = pageW / ratio;

      pdf.addImage(imgData, "PNG", 0, 0, pageW, Math.min(pageH, pdfH));
      pdf.save(filename);
    } catch (err) {
      console.error("PDF generation error:", err);
      alert("PDF generate karne mein error aayi. Please retry.");
    } finally {
      setIsGenerating(false);
    }
  };

  return { downloadPdf, isGenerating };
}